import React from 'react';
import { Helmet } from 'react-helmet';

export default function PageDocumentTitle({ title }) {
    if (!title) return null;
    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
}
